import styled from "@emotion/styled"
import { get } from "lodash"
import React from "react"
import tw from "twin.macro"
import AwardsBlock from "./BlockAwards"
import CardsBlock from "./BlockCards"
import IconGridBlock from "./BlockIconGrid"
import IconListBlock from "./BlockIconList"
import ImageBlock from "./BlockImage"
import LinksBlock from "./BlockLinks"
import MediaGridBlock from "./BlockMediaGrid"
import TestimonialBlock from "./BlockTestimonials"
import TextBlock from "./BlockText"
import TwoColumnLayout from "./BlockTwoColumnLayout"
import VideoBlock from "./BlockVideo"
import TimelineBlock from "./BlockTimeline"

const Block = styled.div`
  & + & {
    ${tw`mt-4 lg:mt-8`}
  }
`

const Content = ({ blocks, alignText, contrastText }) => {

  return (
    blocks.map(block => {
      const type = get(block, "system.type")
      const id = get(block, "system.id")

      return (
        <Block key={id}>
          {{
            awards: <AwardsBlock block={block} />,
            cards: <CardsBlock block={block} />,
            icon_grid: <IconGridBlock block={block} />,
            icon_list: <IconListBlock block={block} />,
            links: (
              <LinksBlock
                block={block}
                alignText={alignText}
                contrastText={contrastText}
              />
            ),
            image_block: <ImageBlock block={block} />,
            media_grid: <MediaGridBlock block={block} />,
            text_block: (
              <TextBlock block={block} contrastText={contrastText} />
            ),
            two_column_layout: (
              <TwoColumnLayout block={block} contrastText={contrastText} />
            ),
            testimonials: (
              <TestimonialBlock block={block} contrastText={contrastText} />
            ),
            timeline: (
              <TimelineBlock block={block} contrastText={contrastText} />
            ),
            video_block: <VideoBlock block={block} />,
          }[type] || <>Unhandled: {type}</>}
        </Block>
      )
    })
  )
}

export default Content
